<section>
  @defer(on viewport) {
  <header class="text-center">
    <h2 class="h3-responsive font-bold mb-8">4 REASONS WHY!</h2>
  </header>
  <section class="flex flex-col sm:flex-row items-center justify-center gap-2">
    @for (reason of reasons; let step = $index; track $index) {
    <article class="reason-why mon-card">
      <div class="step">{{ step + 1 }}</div>
      <div class="flex flex-col items-center justify-between">
        <img class="inline-block mt-2" [ngSrc]="reason.imageLink" alt="reason icon" width="90" height="90" />
        <p class="h4-responsive font-bold my-4">
          {{ reason.title }}
        </p>
        <p class="text-gray-500 h5-responsive">
          {{ reason.description }}
        </p>
      </div>
    </article>
    }
  </section>
  }@placeholder {
  <div class="spinner-center">
    <mat-spinner></mat-spinner>
  </div>
  }
</section>
